import { createValidation } from '_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'
import * as Yup from 'yup'

export const adicionaItemSchema = (t: TFunction) => {
  const v = createValidation(t)

  return Yup.object().shape({
    observacao: Yup.string().trim().max(512, v.maxField(512)).nullable().notRequired(),
    valorEmpresa: Yup.number()
      .transform((value, originalValue) =>
        originalValue === '' || originalValue === null ? undefined : value
      )
      .notRequired(),
    valorProfissional: Yup.number()
      .transform((value, originalValue) =>
        originalValue === '' || originalValue === null ? undefined : value
      )
      .notRequired(),
    fatura: Yup.object().nullable().required(v.requiredField('fatura', 'select')),
  })
}
